angular.module('impactx.panel').controller('PanelCtrl', PanelCtrl);

PanelCtrl.$inject = ['$redirect'];

function PanelCtrl($redirect) {

    this.link = function (dest) {
        $redirect.redirectTo(null, dest);
    }

}